import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../components/Transition';
import { NumericFormatCustom } from '../../components/NumericCustomFormatter';
import { getAssetURl } from '../../utils/url';
import { uploadAssets } from '../../utils/uploadAssets';
import { useAppSelector } from '../../store';
import { DocumentType } from '../../enum';
import { RiUploadCloud2Fill } from 'react-icons/ri';
import { useState } from 'react';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (key: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  resetForm: () => void;
}

const PropertyCategoryFormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  errors,
  touched,
  values,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleSubmit,
  resetForm,
}) => {
  const [fileName, setFileName] = useState<string>('');
  const { accessToken } = useAppSelector((state) => state.auth);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    documentType: string,
    field: string
  ) => {
    if (event.target.files?.[0]) {
      const uploadResult: any = await uploadAssets(
        event.target.files?.[0],
        documentType,
        accessToken
      );
      if (uploadResult?.data?.id) {
        setFieldValue(field, uploadResult?.data?.keypath);
        setFileName(event.target.files?.[0]?.name);
      }
    }
  };

  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        setFileName('');
        onClose();
      }}
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle sx={{ mt: -0.5, mb: -0.5 }}>Property Category</DialogTitle>
      <form
        onSubmit={handleSubmit}
        autoComplete='off'
      >
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                fullWidth
                label={'Label En'}
                name='labelEn'
                id='labelEn'
                onChange={handleChange}
                value={values.labelEn}
                error={Boolean(errors.labelEn && touched.labelEn)}
                helperText={
                  Boolean(errors.labelEn && touched.labelEn) && errors?.labelEn
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                fullWidth
                label={'Label Ar'}
                name='labelAr'
                id='labelAr'
                onChange={handleChange}
                value={values.labelAr}
                error={Boolean(errors.labelAr && touched.labelAr)}
                helperText={
                  Boolean(errors.labelAr && touched.labelAr) && errors?.labelAr
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                fullWidth
                label={'Position'}
                name='position'
                id='position'
                onChange={handleChange}
                InputProps={{
                  inputComponent: NumericFormatCustom as any,
                }}
                value={values.position}
                error={Boolean(errors.position && touched.position)}
                helperText={
                  Boolean(errors.position && touched.position) &&
                  errors?.position
                }
              />
            </Grid>

            <Grid
              item
              xs={values?.icon ? 8.5 : 12}
              sm={values?.icon ? 8.5 : 12}
            >
              {/* <TextField
                type='file'
                fullWidth
                name='icon'
                id='icon'
                onChange={(e) =>
                  handleFileChange(
                    e as React.ChangeEvent<HTMLInputElement>,
                    DocumentType.PropertyCategory,
                    'icon'
                  )
                }
                inputProps={{ multiple: false, accept: 'image/*' }}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
                label={'Icon'}
                error={Boolean(errors.icon && touched.icon)}
                helperText={Boolean(errors.icon && touched.icon) && errors.icon}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='start'>%</InputAdornment>
                  ),
                }}
              /> */}
              <TextField
                fullWidth
                variant='outlined'
                InputLabelProps={{ shrink: true }}
                label='Icon'
                placeholder='Select Icon'
                value={fileName}
                error={Boolean(errors.icon && touched.icon)}
                helperText={Boolean(errors.icon && touched.icon) && errors.icon}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position='end'>
                      <label htmlFor='icon'>
                        <IconButton component='span'>
                          <RiUploadCloud2Fill />
                        </IconButton>
                      </label>
                    </InputAdornment>
                  ),
                }}
              />
              <input
                id='icon'
                name='icon'
                type='file'
                style={{ display: 'none' }}
                onChange={(e) =>
                  handleFileChange(
                    e as React.ChangeEvent<HTMLInputElement>,
                    DocumentType.PropertyCategory,
                    'icon'
                  )
                }
                accept='image/*'
              />
            </Grid>
            {values?.icon && (
              <Grid
                item
                xs={3.5}
                sm={3.5}
              >
                <Avatar
                  imgProps={{ crossOrigin: 'anonymous' }}
                  src={getAssetURl(values?.icon)}
                  sx={{
                    borderRadius: 'unset',
                    m: 1,
                    objectFit: 'contain',
                    '& img': { objectFit: 'contain' },
                    width: { xs: '75px', sm: '100px' },
                    height: 50,
                  }}
                />
              </Grid>
            )}

            <Grid
              item
              xs={12}
              sm={6}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    name='activeState'
                    onChange={(e) =>
                      setFieldValue('activeState', e.target.checked)
                    }
                    checked={values.activeState}
                  />
                }
                label={'Active Status'}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    name='isLand'
                    onChange={(e) => setFieldValue('isLand', e.target.checked)}
                    checked={values.isLand}
                  />
                }
                label={'Land'}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetForm();
              setFileName('');
              onClose();
            }}
            variant='outlined'
          >
            {'Cancel'}
          </Button>
          <LoadingButton
            type='submit'
            loading={isSubmitting}
            variant='contained'
          >
            {'Save'}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PropertyCategoryFormModal;
